
export const AddressBarMenuIconString = "↔";
export const AddressBarMenuIcon = () => (<>${AddressBarMenuIconString}</>)

export const ExGiv = () => (<><i>e.g.</i>,&nbsp;</>);